import { Outlet } from "react-router-dom";

import Navbar from "../components/shared/Navbar";
import Footer from "../components/shared/Footer";
import ScrollManager from "../components/shared/ScrollManager";

/** Layout for public portfolio pages: sticky navbar + footer. */
const SiteLayout = () => {
  return (
    <div className="site-layout">
      <ScrollManager />
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      <Navbar />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
